export enum CLAN_PAGES {
  HOME_PAGE = "/clans",
  CLANS_PAGE = "/clans/clans-page",
  LEADERBOARD = "/clans/leaderboard",
  NOT_FOUND = "/clans/not-found",
  HUT = "/clans/clan-hut",
  BANK = "/clans/bank",
  ALTAR = "/clans/altar",
  CLAN_PAGE = "/clans/clan"
}
